import styles from './NewsletterBlock.module.css'
import clsx from 'clsx'
import { BasicStyledComponent, DSSubscription } from 'shared-definitions/types'
import AppImage from 'shared-components/ui/AppImage'
import Linked from 'shared-components/service/Linked'
import ButtonCheckbox from 'shared-components/buttons/ButtonCheckbox'
import { useCallback } from 'react'
import { ThemeContext } from 'shared-components/contexts/ThemeContext'

interface NewsletterBlockProps extends BasicStyledComponent {
  block: DSSubscription
  active: boolean
  onChoose: () => void
  company: string
  disableSubscribe: boolean
}

const NewsletterBlock: React.VFC<NewsletterBlockProps> = ({
  block,
  active,
  company,
  onChoose,
  className,
  disableSubscribe,
}) => {
  const { theme } = ThemeContext.useContainer()
  const checkboxClick = useCallback(() => onChoose(), [onChoose])
  return (
    <div className={className}>
      {block.image ? (
        <AppImage
          layout="raw"
          imageClassName={clsx(styles.image, {
            [styles.imageInverted]: theme === 'dark',
          })}
          image={block.image}
          sizes="rem(240)"
          className={styles.picture}
        />
      ) : (
        <>
          <div className={styles.company}>{company}</div>
          <div className={styles.subscriptionName}>{block.title}</div>
        </>
      )}
      <div className={styles.text}>{block.text}</div>
      {block.button ? (
        <Linked className={styles.readMoreLink} {...block.button.pLink}>
          {block.button.label}
        </Linked>
      ) : null}
      {!disableSubscribe && (
        <ButtonCheckbox className={styles.checkbox} active={active} onClick={checkboxClick}>
          {'Subscribe'}
        </ButtonCheckbox>
      )}
    </div>
  )
}

export default NewsletterBlock
